module.exports = __webpack_public_path__ + "img/tiktok-icon.d4416f10.svg";